import {
    apiUpdateTermsAndCondition,
    apiGetTermsAndCondition
} from '../../api/pdpa.js'

export const actions = {
    async fetchTermsAndCondition() {
        const rs = await apiGetTermsAndCondition();
        return rs.data.success ? rs.data.data.status : null
    },
    async updateTermsAndCondition({ commit }, status) {
        try {
            const rs = await apiUpdateTermsAndCondition(status);
            return rs.data.success ? rs.data.success : null
        } catch (error) {
            throw new Error(error)
        }
    }
}